import styled, { keyframes } from 'styled-components';

// Same animation the theme's CssBaseline injects for `.start`/`.stop` (libs/html/theme
// overrides/loadingAnimations.js). Scoped here so apps that don't render CssBaseline
// (youfeel) don't show a permanent bar.
const loadingData = keyframes`
  0% { transform: scaleX(0); }
  55% { transform: scaleX(1); }
  100% { transform: translate(100%); }
`;
const stopLoadingData = keyframes`
  0% { transform: scaleY(1); }
  100% { transform: scaleY(0); opacity: 0; }
`;
const Wrapper = styled.div`
  position: absolute;
  height: 2px;
  background-color: #4cacb9;
  width: 100%;
  margin-bottom: 7px;
  transform-origin: 0%;
  opacity: 1;
  top: 0px;
  z-index: 1111;

  &.start {
    animation: ${loadingData} 2s infinite;
  }

  &.stop {
    animation: ${stopLoadingData} 0.5s forwards;
  }
`;
export { Wrapper };